import { useMemo } from "react";
import constate from "constate";
import { useFeatureFlags } from "@chronosphereio/core";
function useConfigInternal(args) {
    const featureFlags = useFeatureFlags();
    return useMemo(()=>({
            featureFlags,
            ...args
        }), [
        args,
        featureFlags
    ]);
}
const [VizFrameworkConfigProvider, useConfigStrict] = constate(useConfigInternal);
function useVizFrameworkConfig() {
    try {
        return useConfigStrict();
    } catch (_e) {
        return;
    }
}
export { VizFrameworkConfigProvider, useConfigStrict, useVizFrameworkConfig };

//# sourceMappingURL=config.js.map